import AbstractService from "@/services/AbstractService";

export default class ProductService extends AbstractService {
  constructor() {
    super();
  }

  fetch() {
    return this.axios.get("product");
  }

  fetchCategories() {
    return this.axios.get("product/category");
  }

  getProduct(id) {
    return this.axios.get(`product/${id}`);
  }
}
